import { Col, Row } from "react-bootstrap";
import { Field } from "react-final-form";
import { useTranslation } from "react-i18next";
import BMXTextField from "../../../../../Components/Inputs/BMXTextField/BMXTextField";
import BMXSeparator from "../../../../../Components/Separator/BMXSeparator";

const ComplaintFormStepTwo = (props) => {
  const { t } = useTranslation();

  return (
    <div style={{ justifyContent: "flex-start" }}>
      <BMXSeparator title={t("global:complaint.secondary")} />
      <Row>
        <Col xs={12}>
          <Field
            name="advertiserExpectations"
            label={`${t("global:complaint.advertiserExpectations")}`}
            component={BMXTextField}
            data-cy="advertiserExpectations"
            multiline={true}
            maxRows={5}
          />
        </Col>      
      </Row>
      <Row>
        <Col xs={12}>
          <Field
            className="mt-5"
            name="comments"
            label={`${t("global:complaint.comments")}`}
            component={BMXTextField}
            data-cy="comments"
            multiline={true}
            maxRows={5}
          />
        </Col>      
      </Row>
    </div>
  );
};

export default ComplaintFormStepTwo;
